export enum AuthorityCompany {
  REGISTER_COMPANY_CUSTOM_TERMS_CREATE = '12.1.2',
  REGISTER_COMPANY_CUSTOM_TERMS_UPDATE = '12.1.3',
  REGISTER_COMPANY_CUSTOM_TERMS_DELETE = '12.1.4',
  REGISTER_COMPANY_BANK_SLIP_VIEW = '1.1.5',
  REGISTER_COMPANY_EDIT = '1.1.4',
  REGISTER_COMPANY_DELETE = '1.1.3',
  REGISTER_COMPANY_ADD = '1.1.2',
  REGISTER_COMPANY_VIEW = '1.1.1',
  REGISTER_COMPANY_REGISTRATION_COMPANY = '1.1',
  REGISTER_COMPANY_REGISTRATION = '1.',
}
